import { render, staticRenderFns } from "./constructionInfo.vue?vue&type=template&id=21ac6cf0"
import script from "./constructionInfo.vue?vue&type=script&lang=js"
export * from "./constructionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ac6cf0')) {
      api.createRecord('21ac6cf0', component.options)
    } else {
      api.reload('21ac6cf0', component.options)
    }
    module.hot.accept("./constructionInfo.vue?vue&type=template&id=21ac6cf0", function () {
      api.rerender('21ac6cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionInfo.vue"
export default component.exports